var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.title,attrs:{"id":_vm.title}},[_c('h2',[_vm._v(_vm._s(_vm.$props.title))]),_c('div',{staticClass:"underline"}),_vm._t("default",[_vm._v("No section content available.")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }